module.exports = fox._r("images/promo/open-menu-arr.gif", __webpack_public_path__ + "_/_/_/common/frame/images/promo/open-menu-arr.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/open-menu-arr.gif
// module id = 178
// module chunks = 2